module.exports = __webpack_public_path__ + "static/NF_Logo-eed50a87445d1b42b99a81912e799711.png";